module.exports = __webpack_public_path__ + "static/media/thumbs_dsc_1403.3d9c6480.jpg";